import { render } from "./statement_form.vue?vue&type=template&id=22f91046&scoped=true"
import script from "./statement_form.vue?vue&type=script&lang=js"
export * from "./statement_form.vue?vue&type=script&lang=js"

import "./statement_form.vue?vue&type=style&index=0&id=22f91046&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f91046"]])

export default __exports__